import { ChangeStoreStyleTokens } from "@omni/ui/brand/callToActions/changeStore/changeStore.tokens";

export const ChangeStoreStyles: ChangeStoreStyleTokens = {
    confirmButton: {
        color: "primary"
    }
};
